<h1 mat-dialog-title>Search Place</h1>
<div mat-dialog-content>
    <app-search-place (placeSelected)="onPlaceSelected($event)"></app-search-place>
  </div>
  <div mat-dialog-actions>
    <button mat-raised-button mat-dialog-close>Cancel</button>
</div>